import { ImpactType } from '@store/services/projects/types';
import { themePalette } from '@theme/muiTheme';

export const KeyControlsImpactColor: Record<ImpactType, string> = {
  [ImpactType.High]: themePalette.system.error,
  [ImpactType.Medium]: themePalette.system.alert,
  [ImpactType.Low]: themePalette.system.success,
};
